import { TextureLoader, FrontSide, RawShaderMaterial, Vector3 } from "three";

import VERTEX_SHADER from "./shader/plates.vert"
import FRAGMENT_SHADER from "./shader/plates.frag"

const textureLoader = new TextureLoader();

const plateMaterial = new RawShaderMaterial({
    uniforms: {
        lightMap: {
            type: "t",
            value: textureLoader.load( 'media/light.png' )
        },
        cameraPos: {
            value: new Vector3(0,0,0)
        }
    },
    vertexShader: VERTEX_SHADER,
    fragmentShader: FRAGMENT_SHADER,
    side: FrontSide,
    transparent: false
});

export default plateMaterial;
